import { render, staticRenderFns } from "./AddPetitionComment.vue?vue&type=template&id=71f84c9e"
import script from "./AddPetitionComment.vue?vue&type=script&lang=js"
export * from "./AddPetitionComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports